import { useContext } from "react";
import { FirebaseAuthCtx } from "@/components/FirebaseAuthSync";

/**
 * Canonical auth hook. Exposes readiness, the Firebase user (or null), a
 * derived `isAuthenticated` flag (true under Playwright test mode too), and
 * `testMode` so components can guard real-user reads in E2E runs.
 */
export function useAuth() {
  return useContext(FirebaseAuthCtx);
}
